import React from "react";
import isString from "lodash/isString";
import Portal from "@reach/portal";
import classNames from "classnames";
import Size from "shared/enums/Size";
import { SliderProps } from "./slider";
import Direction from "shared/enums/Direction";
import { useCopies } from "shared/hooks/useCopies";
import ScrollShadowComponent from "../scrollShadow";
import { ACTIVITY_SLIDER_BODY_HEIGHT } from "shared/utils/constants";
import Button from "../button";
import Variant from "shared/enums/Variant";

function Slider({ direction = Direction.RIGHT, size = Size.MEDIUM, ...props }: SliderProps) {
  const copies = useCopies();
  const computedClassNames = React.useMemo(
    () =>
      classNames(props.className, {
        slider: true,
        [`slider--${size}`]: size,
        [`slider--${direction}`]: direction
      }),
    [direction, size, props.className]
  );

  React.useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <Portal>
      <div data-testid="slider_modal" className={classNames("slider_wrapper", props.parentClassName)}>
        <div className={computedClassNames}>
          <div className="slider_header">
            <label {...(isString(props.title) ? { title: props.title } : {})}>{props.title}</label>
            {props.actionButton && <span className="actionButton">{props.actionButton}</span>}
            {props.handleClose && (
              <Button.Close
                className="slider_close"
                title={copies.get("close")}
                variant={Variant.ERROR}
                onClick={props.handleClose}
              />
            )}
          </div>
          {props.enableScrollShadowEffect ? (
            <ScrollShadowComponent maxHeight={ACTIVITY_SLIDER_BODY_HEIGHT}>
              <div className="slider_body">{props.children}</div>
            </ScrollShadowComponent>
          ) : (
            <div className="slider_body sliderBodyOverflow">{props.children}</div>
          )}
        </div>
      </div>
    </Portal>
  );
}

export default Slider;
